"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDashboardPlugin = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
function convertDashboardPlugin(plugin) {
    var _a;
    var _b = plugin.dashboardPlugin, url = _b.content.url, _c = _b.meta, title = _c.title, summary = _c.summary, uri = _c.uri, identifier = _c.identifier, updated = _c.updated, created = _c.created, tags = _c.tags;
    return {
        type: "IDashboardPlugin",
        name: title,
        description: summary !== null && summary !== void 0 ? summary : "",
        uri: uri,
        identifier: identifier,
        updated: updated,
        created: created,
        tags: (_a = tags === null || tags === void 0 ? void 0 : tags.split(" ").filter(function (t) { return t; })) !== null && _a !== void 0 ? _a : [],
        ref: sdk_model_1.uriRef(uri),
        url: url,
    };
}
exports.convertDashboardPlugin = convertDashboardPlugin;
//# sourceMappingURL=plugin.js.map